import {
  Bell, Calendar, ChatCircleDots, Eye, FileText, Megaphone, Scales,
} from "@phosphor-icons/react";

export const ICONS = {
  bell: Bell, megaphone: Megaphone, scale: Scales, scales: Scales,
  document: FileText, calendar: Calendar, message: ChatCircleDots, eye: Eye,
};

export const POLL_MS = 30000;

export const BUCKET_LABEL = { today: "اليوم", yesterday: "أمس", week: "هذا الأسبوع", older: "الأقدم" };

export function relativeAr(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "الآن";
  if (diff < 3600) return `قبل ${Math.floor(diff / 60)} د`;
  if (diff < 86400) return `قبل ${Math.floor(diff / 3600)} س`;
  if (diff < 604800) return `قبل ${Math.floor(diff / 86400)} يوم`;
  return d.toLocaleDateString("ar-IQ", { year: "numeric", month: "short", day: "numeric" });
}

export function bucketOf(iso) {
  if (!iso) return "older";
  const d = new Date(iso).setHours(0, 0, 0, 0);
  const t = new Date().setHours(0, 0, 0, 0);
  const days = Math.round((t - d) / 86400000);
  if (days <= 0) return "today";
  if (days === 1) return "yesterday";
  if (days < 7) return "week";
  return "older";
}
